module.exports = __webpack_public_path__ + "img/idphoto_null@3x.e0a2e7ec.png";